// src/pages/FulfillmentPage/hooks/useFulfillmentActions.ts
import { useState } from "react";
import {
  startFulfillment,
  markReady,
  completeFulfillment,
  markDelivered,
} from "../../../api/fulfillmentApi";
import { Fulfillment } from "../types";

export function useFulfillmentActions(fulfillment: Fulfillment | null, onSuccess: () => void) {
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAction = async (action: () => Promise<void>) => {
    if (!fulfillment) return;
    
    setActionLoading(true);
    setError(null);
    
    try {
      await action();
      await onSuccess();
    } catch (e: any) {
      console.error(e);
      setError(e?.response?.data?.error || "Action failed.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleStart = () => handleAction(() => startFulfillment(fulfillment!.id));
  const handleMarkReady = () => handleAction(() => markReady(fulfillment!.id));
  
  const handleComplete = (payload?: any) => 
    handleAction(async () => {
      await completeFulfillment(fulfillment!.id, payload);
    });

  const handleMarkDelivered = (deliveryMessage?: string | null) =>
    handleAction(() => markDelivered(fulfillment!.id, deliveryMessage));

  return {
    actionLoading,
    actionError: error,
    setActionError: setError,
    setActionLoading, // ✅ Add this line to return the setter
    handleAction,
    handleStart,
    handleMarkReady,
    handleComplete,
    handleMarkDelivered,
  };
}